import React, { useState } from 'react';
import PhotoUpload from './PhotoUpload';

const QuoteRequest = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    description: '',
    budget: '',
    timeline: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePhotoUpload = (files) => {
    // Here you would typically handle the file upload
    console.log('Files to upload:', files);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form data:', formData);
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold mb-4">Demander un Devis</h2>
        <p className="text-textSecondary">
          Remplissez le formulaire ci-dessous et nous vous contacterons dans les plus brefs délais
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-textSecondary mb-2">Nom complet</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              required
            />
          </div>

          <div>
            <label className="block text-textSecondary mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              required
            />
          </div>

          <div>
            <label className="block text-textSecondary mb-2">Téléphone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              required
            />
          </div>

          <div>
            <label className="block text-textSecondary mb-2">Type de projet</label>
            <select
              name="projectType"
              value={formData.projectType}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              required
            >
              <option value="">Sélectionnez un type</option>
              <option value="residential">Résidentiel</option>
              <option value="commercial">Commercial</option>
              <option value="interior">Design d'intérieur</option>
              <option value="exterior">Rénovation extérieure</option>
            </select>
          </div>

          <div>
            <label className="block text-textSecondary mb-2">Budget estimé</label>
            <input
              type="text"
              name="budget"
              value={formData.budget}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              placeholder="€"
            />
          </div>

          <div>
            <label className="block text-textSecondary mb-2">Délai souhaité</label>
            <input
              type="text"
              name="timeline"
              value={formData.timeline}
              onChange={handleInputChange}
              className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
              placeholder="ex: 3 mois"
            />
          </div>
        </div>

        <div>
          <label className="block text-textSecondary mb-2">Description du projet</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-4 py-2 bg-surface border border-gray-700 rounded-md text-text"
            required
          ></textarea>
        </div>

        <PhotoUpload
          onUpload={handlePhotoUpload}
          title="Photos du projet"
          description="Ajoutez des photos de votre espace à rénover (max 5 photos)"
        />

        <button type="submit" className="btn btn-primary w-full">
          Envoyer la demande
        </button>
      </form>
    </div>
  );
};

export default QuoteRequest; 